module.exports = __webpack_public_path__ + "static/cmac-9acb996ed22614d33e63eedd2ba3aa94.jpeg";